import { PDFDocument } from 'pdf-lib';

export const signPdf = async (png: string, pdf: ArrayBuffer): Promise<Uint8Array> => {
  const pdfDoc = await PDFDocument.load(pdf);
  const image = await pdfDoc.embedPng(png);

  const pages = pdfDoc.getPages();
  const lastPage = pages[pages.length - 1];

  lastPage.drawImage(image, {
    height: 80,
    width: 150,
    x: 350,
    y: 350,
  });

  const signedPdf = await pdfDoc.save();
  return signedPdf;
};
